import { AcornsIcon } from '@acorns/icons'
import { Button, Heading } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

import { DirectDepositCard } from '../SharedComponents'

const XS_WIDTH = 320
const XXS_WIDTH = 280

export const StyledDirectDepositCard = styled(DirectDepositCard)`
  position: relative;
  margin-bottom: 0;
`

export const ContentContainer = styled.div`
  width: calc(100% - 80px);
  min-height: calc(100vh - 147px);
  padding: 80px 0 118px 80px;

  @media (max-width: ${style((theme) => theme.breakpoints.md)}px) {
    max-width: none;
    padding-right: 80px;
    padding-bottom: 118px;
  }

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    width: auto;
    padding: 10px 30px 100px 30px;
  }
`

export const StyledHeading = styled(Heading)`
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
  margin-bottom: 20px;
  @media (max-width: ${XS_WIDTH}px) {
    font-size: 22px;
    line-height: 30px;
  }
`

export const StyledHeadingEarlyPayday = styled(Heading)`
  font-size: 40px;
  font-weight: 600;
  line-height: 55px;
  max-width: 400px;
  margin-bottom: 10px;

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    font-size: 30px;
    line-height: 41px;
  }
`

export const StyledSubheading = styled.div`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 30px;

  > sup {
    line-height: 1;
    top: -0.4em;
  }
`

export const BodyCard = styled.div`
  box-shadow: ${style((theme) => theme.shadows.smMedium)};
  height: 140px;
  width: 340px;
  border-radius: ${style((theme) => theme.borderRadius.large)};
  position: relative;
  z-index: 2;
  background-color: ${style((theme) => theme.colors.white)};
  padding: 20px;
  margin-top: 30px;
  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    width: 315px;
  }
  @media (max-width: ${XS_WIDTH}px) {
    width: 260px;
  }
  @media (max-width: ${XXS_WIDTH}px) {
    width: 220px;
  }
`

export const NumberLabel = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`

export const StyledNumber = styled.div`
  font-size: 14px;
  line-height: 22px;
  margin-top: 2px;
`

export const Row = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`

export const CopyButton = styled.button`
  background-color: ${style((theme) => theme.colors.ivory)};
  border-radius: ${style((theme) => theme.borderRadius.large)};
  border: 0;
  cursor: pointer;
  height: 36px;
  width: 36px;
`

export const DownloadButton = styled(Button)`
  background-color: ${style((theme) => theme.colors.slate)};
  margin-bottom: 30px;
  z-index: 2;
  &:hover {
    background-color: ${style((theme) => theme.colors.slate)};
  }
`

export const StyledUtilityArrowRight = styled(AcornsIcon)`
  margin-left: 10px;
  path {
    &[fill] {
      fill: ${style((theme) => theme.colors.white)};
    }
  }
`

export const StyledIncentiveContainer = styled.div`
  margin-bottom: 30px;
`

export const StyledIncentiveRow = styled.div`
  font-size: 14px;
  line-height: 22px;
  &:not(:last-child) {
    margin-bottom: 15px;
  }
  display: flex;
`

export const IconContainer = styled.div`
  padding-top: 16px;
  margin-right: 14px;
`

export const EarlyPaydayIconContainer = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
`

export const StyledCheckmark = styled(AcornsIcon)`
  path {
    &[stroke] {
      stroke: ${style((theme) => theme.colors.green)};
    }
  }
`

export const DisclaimerContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 368px;
  gap: 20px;

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    max-width: 315px;
  }
`

export const DisclaimerText = styled.div`
  font-size: 14px;
  line-height: 22px;
  margin-top: 30px;
`

export const EarlyPaydayDisclaimerText = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${style((theme) => theme.colors.stone)};

  > sup {
    line-height: 1;
    top: -0.4em;
  }
`

export const GreenDisclaimerText = styled.span`
  color: ${style((theme) => theme.colors.green)};
  font-weight: 500;
  cursor: pointer;
`

export const DirectDepositImg = styled.img`
  max-width: 565px;
  position: absolute;
  bottom: 0;
  right: 0;
  border-bottom-right-radius: ${style((theme) => theme.borderRadius.large)};

  @media (max-width: ${style((theme) => theme.breakpoints.md)}px) {
    max-width: 470px;
  }
`

export const EarlyPaydayImg = styled(DirectDepositImg)`
  max-width: 211px;
  @media (max-width: ${style((theme) => theme.breakpoints.md)}px) {
    max-width: 180px;
  }

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    max-width: 146px;
  }
`
